var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { consumerTheme, fontWeights, colors as syfColors, fontSizes as syfFontSizes, spacing as syfSpacing } from 'syf-component-library/defaultTheme';
var colors = __assign(__assign({}, syfColors), { trueBlack: '#000000', mutedGray: '#22242626', alabaster: '#fafafa', nero: '#232323' });
var spacing = __assign(__assign({}, syfSpacing), { root: 16 });
var fontSizes = __assign({ regular: 14 }, syfFontSizes);
export { colors, fontSizes, fontWeights, spacing };
export default consumerTheme;
